var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsXBlack = function SvgIconsXBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.4 7-5.65 5.651L8.1 7 7 8.1l5.65 5.651L7 19.401l1.099 1.1 5.651-5.65 5.65 5.65 1.101-1.1-5.65-5.65 5.65-5.65z",
    fillRule: "evenodd"
  })));
};
export { SvgIconsXBlack as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Im0xOS40IDctNS42NSA1LjY1MUw4LjEgNyA3IDguMWw1LjY1IDUuNjUxTDcgMTkuNDAxbDEuMDk5IDEuMSA1LjY1MS01LjY1IDUuNjUgNS42NSAxLjEwMS0xLjEtNS42NS01LjY1IDUuNjUtNS42NXoiIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L3N2Zz4K";